import type {
  ListingApplicationPayload,
  NonAtsListingApplicationPayload,
} from 'api/ats';
import { postJson } from 'utils/http/postJson';

type CreateApplicationType = {
  // XXX incomplete
  id: string;
};

export async function userDashboardApiCreateListingApplication(
  payload: ListingApplicationPayload | NonAtsListingApplicationPayload,
): Promise<CreateApplicationType> {
  return postJson<{ listingApplication: CreateApplicationType }>(
    '/data/listing-applications',
    payload,
  ).then(({ listingApplication }) => listingApplication);
}
